module.exports = __webpack_public_path__ + "72b25030805b6f9047bacd4f1a448856.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/logo.png
// module id = 525
// module chunks = 10